import { useNavigate } from 'react-router-dom';
import {
  DateRangeKey,
  generateDateRangeFilter,
} from '../../commonUI/DateRangeFilterSelect/utils/generateDateRangeFilter';
import { useLocationState } from '../../router/hooks/useLocationState';

export const useNavigateWithReportDateRange = (
  dateRangeOptions: DateRangeKey[],
  dateRangeKey?: DateRangeKey,
  scanDate?: string
): ((path: string) => void) => {
  const navigate = useNavigate();
  const state = useLocationState();

  if (!dateRangeKey && state.dateRangeKey) {
    dateRangeKey = state.dateRangeKey; // try to fallback to the date range key from the state
  }

  if (dateRangeKey) {
    return (path: string) => navigate(path, { state: { dateRangeKey } });
  }

  if (!scanDate && state?.scanDate) {
    scanDate = state.scanDate; // try to fallback to the scan date from the state
  }

  if (scanDate) {
    const date = new Date(scanDate);
    // find the smallest date range key that contains the scan date
    for (const option of dateRangeOptions) {
      const testRange = generateDateRangeFilter(option);

      if (testRange && testRange.start <= date) {
        return (path: string) =>
          navigate(path, {
            state: { dateRangeKey: option },
          });
      }
    }
  }

  return navigate; // no date range or scan date available, so just navigate to the path
};
